import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { news } from '@/mocks/news';
import { formatDate } from '@/utils/format';

export default function NewsFeed() {
  const list = news.slice(0, 5);

  return (
    <section aria-label="影视资讯快递">
      <SectionHeading
        title="影视资讯快递"
        subtitle="观影指南、幕后制作与行业观察"
        icon="ri-newspaper-line"
        moreTo="/news"
        moreLabel="全部资讯"
      />
      <div className="divide-y divide-background-200 border-t border-b border-background-200">
        {list.map((article) => (
          <Link key={article.id} to={`/news/${article.id}`} className="group block py-4">
            <div className="flex items-center gap-2 mb-1.5">
              <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900 text-xs">
                {article.category}
              </span>
              <span className="text-xs text-foreground-400">{formatDate(article.date)}</span>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
              {article.title}
            </h3>
            <p className="mt-1.5 text-sm text-foreground-500 line-clamp-2">{article.summary}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}